const maleNames=/\b(abeo|ade|ayo|brian|christopher|daniel|david|femi|george|guy|james|kofi|kojo|kwame|liam|mark|matthew|olamide|oliver|ryan|sekou|thomas|william)\b/i;
const femaleNames=/\b(abena|akosua|amy|aria|ava|emma|hazel|jenny|joanna|libby|natasha|salli|samantha|sonia|susan|victoria|zira)\b/i;

export function selectGhanaianVoice(voices:SpeechSynthesisVoice[]){
  const maleEnglish=voices.filter(voice=>voice.lang.toLowerCase().startsWith('en')&&maleNames.test(voice.name)&&!femaleNames.test(voice.name));
  const modern=maleEnglish.filter(voice=>/(natural|neural|online|premium|enhanced)/i.test(voice.name));
  return (modern.length?modern:maleEnglish)
    .map(voice=>({voice,score:voiceScore(voice)}))
    .sort((a,b)=>b.score-a.score)[0]?.voice;
}

function voiceScore(voice:SpeechSynthesisVoice){
  const name=voice.name.toLowerCase();const lang=voice.lang.toLowerCase();let score=100;
  if(/(natural|neural|online|premium|enhanced)/.test(name))score+=220;
  if(lang==='en-gh'||/(ghana|ghanaian|kofi|kojo|kwame)/.test(name))score+=70;
  else if(['en-ng','en-ke','en-za'].includes(lang)||/(abeo|olamide|ayo|ade|femi|sekou|africa)/.test(name))score+=55;
  else if(lang==='en-gb')score+=25;
  if(voice.localService)score+=5;
  return score;
}

export function supportsMentorSpeech(){return typeof window!=='undefined'&&'speechSynthesis' in window&&typeof SpeechSynthesisUtterance!=='undefined'}
export function cancelMentorSpeech(){if(supportsMentorSpeech())window.speechSynthesis.cancel()}

export function speakMentorText(text:string){
  if(!supportsMentorSpeech()||!text.trim())return false;
  const speak=()=>{
    const voice=selectGhanaianVoice(window.speechSynthesis.getVoices());
    if(!voice)return false;
    window.speechSynthesis.cancel();
    const utterance=new SpeechSynthesisUtterance(smoothScript(text));
    utterance.voice=voice;utterance.lang=voice.lang;utterance.rate=.96;utterance.pitch=1;utterance.volume=1;
    window.speechSynthesis.speak(utterance);return true;
  };
  if(speak())return true;
  window.speechSynthesis.addEventListener?.('voiceschanged',speak,{once:true});
  return false;
}

function smoothScript(text:string){return text.replace(/\s*[—–]\s*/g,', ').replace(/:\s*/g,': ').replace(/\s+/g,' ').trim()}
